import { render, staticRenderFns } from "./SpedizioneDettaglio.vue?vue&type=template&id=9c423bd2&scoped=true"
import script from "./SpedizioneDettaglio.vue?vue&type=script&lang=ts"
export * from "./SpedizioneDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c423bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c423bd2')) {
      api.createRecord('9c423bd2', component.options)
    } else {
      api.reload('9c423bd2', component.options)
    }
    module.hot.accept("./SpedizioneDettaglio.vue?vue&type=template&id=9c423bd2&scoped=true", function () {
      api.rerender('9c423bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SpedizioneDettaglio.vue"
export default component.exports